import { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../common/responsive.js';
import {
  selectTokenByNetworkAndAddress,
  selectLastUpdated,
} from '../../redux/slices/tokenSlice';
import TokenSwap from '../../components/TokenSwap/index.tsx';
import ScrollRestore from '../../components/ScrollRestore/index.tsx';
import { useSolana } from '../../hooks/useSolana';
import { Heading4Text } from '../../components/Texts';
import { useTheme } from 'styled-components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../../components/Button/index.tsx';
import ChevronLeftIcon from '../../assets/icons/chevron-left.svg?react';
import { useLazySearchTokensQuery } from '../../redux/api/public/tokens.js';

const StyledHeading4Text = styled(Heading4Text)`
  @media ${PHONE_MEDIA_QUERY} {
    font-size: 24px;
    margin-top: '15px';
    font-weight: 600;
  }
`;

const TradeContainer = styled.div`
  width: 100%;
  padding-top: 40px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  padding-left: 20px;
  padding-right: 20px;

  @media ${PHONE_MEDIA_QUERY} {
    justify-content: flex-start;
    gap: 8px;
    padding-top: 20px;
    padding-left: 0px;
    padding-right: 0px;
  }
`;

const ContentRow = styled.div`
  display: flex;
  gap: 30px;
  justify-content: flex-start;
  width: 100%;
`;

export const SwapContainer = styled(ContentRow)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
  width: 100%;
  max-width: 800px;

  @media ${PHONE_MEDIA_QUERY} {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const TokenSwapContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.border.primary};
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 500px;

  @media ${PHONE_MEDIA_QUERY} {
    border: unset;
    padding: 0px;
    gap: 8px;
    width: 100%;
  }
`;

const Trade = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const tokenAddress = searchParams.get('tokenAddress');
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const navigate = useNavigate();
  const token = useSelector((state) =>
    selectTokenByNetworkAndAddress(
      state,
      'solana',
      tokenAddress || 'So11111111111111111111111111111111111111112',
    ),
  );

  const { refreshTokenBalances } = useSolana();
  const theme = useTheme();
  const lastUpdated = useSelector(selectLastUpdated);
  const [searchTokens] = useLazySearchTokensQuery();
  useEffect(() => {
    refreshTokenBalances();
  }, [refreshTokenBalances]);

  useEffect(() => {
    if (!token && lastUpdated > 0 && tokenAddress) {
      searchTokens({
        addresses: [tokenAddress],
      });
    }
  }, [token, lastUpdated, tokenAddress, searchTokens]);

  return (
    token && (
      <>
        {!isMobile && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              width: '100%',
              color: theme.text.title,
            }}
          >
            <ChevronLeftIcon width={9} height={48} color={theme.text.title} />
            <Button
              variant='link'
              onClick={() => navigate(-1)}
              style={{ color: theme.text.title }}
            >
              {t('common.back')}
            </Button>
          </div>
        )}
        <ScrollRestore />
        <TradeContainer>
          <StyledHeading4Text
            style={{ alignSelf: 'flex-start', color: theme.text.title }}
          >
            {t('trade.title')}
          </StyledHeading4Text>
          <SwapContainer>
            <TokenSwapContainer>
              <TokenSwap token={token} allowAnyTokenSwap={true} />
            </TokenSwapContainer>
          </SwapContainer>
        </TradeContainer>
      </>
    )
  );
};

export default Trade;
